import { fetchConToken, fetchSinToken } from "../helpers/fetch";
import { types } from "../types/types";
import { citaLogout } from "./citas";
import { comentarioLogout } from "./comentarios";
import { empresaLogout } from "./empresas";
import { horarioLogout } from "./horarios";
import { productoLogout } from "./productos";
import { profesionalLogout } from "./profesionales";
import { promocionLogout } from "./promociones";
import { servicioLogout } from "./servicios";
import { sucursalLogout } from "./sucursales";
import { openModal, openModalBottom } from "./ui";
import { activeUsuario, addNewUsuario, usuarioLogout } from "./usuarios";

const HTTP_NO_AUTORIZADO = 401;


export const startLogin = ( email, password ) => {
    return async( dispatch ) => {
        const resp = await fetchSinToken( 'auth', { email, password }, 'POST');
        const body = await resp.json();

        if( body.ok ) {
            localStorage.setItem( 'barbgest-token', body.token );
            localStorage.setItem( 'barbgest-token-init-date', new Date().getTime() );

            dispatch( login({
                uid: body.uid,
                nombre: body.nombre,
                role: body.role,
                empresa: body.empresa,
                plan: body.plan,
                profesional: body.profesional
            }));
        } else {
            const datos = {
                title: 'Error',
                text: ( Array.isArray( body.msg ) ) ? body.msg : [body.msg],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }

    }
}

export const startLoginBusiness = ( email, password ) => {
    return async( dispatch ) => {
        const empresaId = null;
        const resp = await fetchSinToken( 'auth/login', { email, password, empresaId }, 'POST');
        const body = await resp.json();

        if( body.ok ) {
            localStorage.setItem( 'barbgest-token', body.token );
            localStorage.setItem( 'barbgest-token-init-date', new Date().getTime() );

            dispatch( login({
                uid: body.uid,
                nombre: body.nombre,
                role: body.role,
                empresa: body.empresa,
                plan: body.plan,
                profesional: body.profesional
            }));
        } else {
            const datos = {
                title: 'Error',
                text: ( Array.isArray( body.msg ) ) ? body.msg : [body.msg],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }

    }
}

export const startRegister = ( usuario ) => {
    return async( dispatch ) => {
        const resp = await fetchSinToken( 'auth/new', usuario, 'POST');
        const body = await resp.json();

        if( !body.ok ) {
            const datos = {
                title: 'Error',
                text: [ body.msg ],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }
    }
}

export const startRegisterBusiness = ( usuario ) => {
    return async( dispatch ) => {
        try {
            const resp = await fetchConToken( 'auth/new', usuario, 'POST');
            const body = await resp.json();

            if( body.ok ) {			
                dispatch( addNewUsuario( body.usuario._id, body.usuario ) );
                dispatch( activeUsuario( body.usuario._id, body.usuario ) );
                return { ...body.usuario, _isNew: true };
            } else {
                if( body.code === 'exists' ){
                    try {
                        const searchResp = await fetchConToken( `usuarios/buscar/${usuario.email}`, {empresa: usuario.empresa, from: 0, limit: 1}, 'POST' );
                        const searchBody = await searchResp.json();
                        
                        if( searchBody.clientes && searchBody.clientes.length > 0 ) {
                            const usuarioExistente = searchBody.clientes[0];
                            dispatch( addNewUsuario( usuarioExistente._id, usuarioExistente ) );
                            dispatch( activeUsuario( usuarioExistente._id, usuarioExistente ) );
                            const datos = {
                                text: [ 'El cliente ya existe. Se ha seleccionado automáticamente.' ],
                                timeOut: 3
                            }
                            dispatch( openModalBottom( datos ) );
                            return usuarioExistente;
                        }
                    } catch (searchError) {
                        console.error('Error buscando usuario existente:', searchError);
                    }
                    
                    const datos = {
                        title: 'Error',
                        text: [ 'El cliente ya existe en el sistema' ],
                        buttonText: 'Cerrar'
                    }
                    dispatch( openModal( datos ) );
                } else {
                    const datos = {
                        title: 'Error',
                        text: [ body.msg ],
                        buttonText: 'Cerrar'
                    }
                    dispatch( openModal( datos ) );
                }
                return null;
            }
        } catch (error) {
            console.error('Error en startRegisterBusiness:', error);
            const datos = {
                title: 'Error',
                text: [ 'Ha ocurrido un error al crear el cliente' ],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
            return null;
        }
    }
}

export const startChecking = () => {
    return async( dispatch ) => {
        const resp = await fetchConToken( 'auth/renew' );
        const body = await resp.json();

        if( body.ok ) {
            localStorage.setItem( 'barbgest-token', body.token );
            localStorage.setItem( 'barbgest-token-init-date', new Date().getTime() );

            const obj = {
                uid: body.uid,
                nombre: body.nombre,
                role: body.role,
                empresa: body.empresa,
                plan: body.plan,
                profesional: body.profesional
            };

            dispatch( login(obj) );
        } else {
            dispatch( checkingFinish() );
        }
    }
};

export const startRenovarToken = () => {
    return async( dispatch, getState ) => {
        const uidAlPedirRenovacion = getState().auth.uid;

        let resp;
        let body;
        try {
            resp = await fetchConToken( 'auth/renew' );
            body = await resp.json();
        } catch ( errorDeRed ) {
            // Un fallo de red no invalida la sesion: se reintenta en la siguiente renovacion
            return;
        }

        const sesionCambiadaDuranteLaPeticion = getState().auth.uid !== uidAlPedirRenovacion;
        if( sesionCambiadaDuranteLaPeticion ) return;

        // Solo el 401 dice que la sesion ya no vale (caducada, contraseña cambiada o usuario eliminado).
        // Otros rechazos, como el 400 que recibe un superadmin en el panel de otra empresa, no cierran la sesion.
        const sesionRechazada = resp.status === HTTP_NO_AUTORIZADO;
        if( sesionRechazada ) {
            dispatch( startLogout() );
            return;
        }

        if( !body.ok ) return;

        localStorage.setItem( 'barbgest-token', body.token );
        localStorage.setItem( 'barbgest-token-init-date', new Date().getTime() );
    }
};

const checkingFinish = () => ({ type: types.authCheckingFinish })

const login = ( user ) => ({
    type: types.authLogin,
    payload: user
});

export const sendNewPasswordToken =( email, empresa ) => {
    return async( dispatch ) => {
        const resp = await fetchSinToken( 'auth/reset-url', { email, empresa }, 'POST');
        const body = await resp.json();

        if( body.ok ) {
            const datos = {
                title: 'Enviado',
                text: ['Sigue las instrucciones del e-mail para cambiar tu contraseña'],
                buttonText: 'Aceptar'
            }
            dispatch( openModal( datos ) );
        }
    }
};

export const changePassword = ( token, password ) => {
    return async( dispatch ) => {
        const resp = await fetchSinToken( 'auth/reset', { token, password }, 'POST');
        const body = await resp.json();

        if( !body.ok ) {
            const datos = {
                title: 'Error',
                text: ( Array.isArray( body.msg ) ) ? body.msg : [body.msg],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }

    }
};

export const startLogout = ( history ) => {
    return ( dispatch, getState ) => {
        localStorage.removeItem('barbgest-token');
        localStorage.removeItem('barbgest-token-init-date'); 
        dispatch( usuarioLogout() );
        dispatch( empresaLogout() );
        dispatch( sucursalLogout() );
        dispatch( citaLogout() );
        dispatch( servicioLogout() );
        dispatch( horarioLogout() );
        dispatch( profesionalLogout() );
        dispatch( comentarioLogout() );
        dispatch( promocionLogout() );
        dispatch( productoLogout() );
        dispatch( logout() );
        if( history ){
            history.replace('/auth/login');
        }
    }
};

const logout = () => ({ type: types.authLogout });